<template>
  <div :class="['tm-new-dot', { 'small-button': smallButton }]">
    <slot>
      <div class="default-dot" />
    </slot>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  smallButton: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss" scoped>
$dotSize: 14px;

.tm-new-dot {
  position: absolute;
  top: -6px;
  right: -2px;

  &.small-button {
    top: 1px;
    right: -1px;
  }

  .default-dot {
    width: $dotSize;
    height: $dotSize;
    background: linear-gradient(90.71deg, #aa41cf 7.36%, #4d61c9 85.2%);
    border: 2px solid $lift;
    border-radius: 100%;
  }
}
</style>
